import { c as _c } from "react/compiler-runtime";
import { createChart } from "lightweight-charts";
import { useEffect, useState } from "react";
import { tickMarkFormatter } from "../util/time";
export function usePrepareCandlestickChart(containerRef, interactive) {
  const $ = _c(5);
  const [chart, setChart] = useState(null);
  let t0;
  if ($[0] !== containerRef.current || $[1] !== interactive) {
    t0 = () => {
      if (!containerRef.current) {
        return;
      }
      const container = containerRef.current;
      const containerWidth = container.clientWidth || 800;
      const containerHeight = container.clientHeight || 450;
      const newChart = createChart(container, {
        width: containerWidth,
        height: containerHeight,
        layout: {
          fontFamily: "\"Source Code Pro\", monospace",
          fontSize: 10,
          background: {
            color: "transparent"
          },
          textColor: "#ACADAE",
          attributionLogo: false
        },
        handleScale: {
          mouseWheel: interactive,
          pinch: interactive,
          axisPressedMouseMove: interactive,
          axisDoubleClickReset: interactive
        },
        grid: {
          vertLines: {
            visible: false
          },
          horzLines: {
            color: "#FFFFFF08"
          }
        },
        crosshair: {
          vertLine: {
            color: "#FFFFFF28",
            width: 1,
            labelVisible: false
          },
          horzLine: {
            visible: false,
            labelVisible: false
          }
        },
        rightPriceScale: {
          borderVisible: false,
          ensureEdgeTickMarksVisible: true,
          scaleMargins: {
            top: 0,
            bottom: 0.2
          }
        },
        timeScale: {
          borderVisible: false,
          fixLeftEdge: true,
          fixRightEdge: true,
          timeVisible: true,
          minBarSpacing: 0.5,
          tickMarkFormatter
        },
        autoSize: true
      });
      setChart(newChart);
      return () => {
        newChart.remove();
        setChart(null);
      };
    };
    $[0] = containerRef.current;
    $[1] = interactive;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== containerRef) {
    t1 = [containerRef];
    $[3] = containerRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  return chart;
}